import { TAppState } from '../../types/appState';

export function alertSelector(state: TAppState) {
  return state.alert;
}
